import { httpClient } from '@/utils/httpClient';
import type { StatEntry } from '@/features/tech-support/types';

/** Largest page the API serves for statistics; it caps larger requests at this size. */
export const STATISTICS_PAGE_SIZE = 500;

interface StatisticsPage {
  data?: StatEntry[];
  recordsTotal?: number;
}

/**
 * Every statistics row (one per account and API) in the API's default window, the last 31 days,
 * read page by page so no row is cut off by the server's page cap. Totals summed over the result
 * therefore cover every account, not only the first page.
 */
export async function fetchAllStatistics(): Promise<StatEntry[]> {
  const rows: StatEntry[] = [];
  for (let start = 0; ; start += STATISTICS_PAGE_SIZE) {
    const res = await httpClient.get<StatisticsPage>(
      `/admin/account/GetAccountStatistics?draw=1&length=${STATISTICS_PAGE_SIZE}&start=${start}&search=&column=accountName&orderBy=asc`,
    );
    const page = res.data?.data ?? [];
    rows.push(...page);
    const total = res.data?.recordsTotal ?? rows.length;
    if (page.length === 0 || page.length < STATISTICS_PAGE_SIZE || rows.length >= total) return rows;
  }
}
